import * as _ from 'lodash';

import BaseResource from './base-resource';
import SiteResource from './site-resource';
import JsonApiReference from './jsonapi-reference';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class ReportScheduleResource extends BaseResource {
  site: SiteResource = new SiteResource();
  sendInterval: any;
  reportName: string;

  intervalName() {
    if (!this.sendInterval) {
      return '';
    } else if (this.sendInterval.type === 1) {
      return 'Daily';
    } else if (this.sendInterval.type === 2) {
      return 'Weekly';
    } else if (this.sendInterval.type === 3) {
      return 'Monthly';
    }
  }

  constructor(init?: Partial<ReportScheduleResource>) {
    super(init, 'epx-report-schedules');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/report-schedule-resource.ts